/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Reset_TitleInputs */



/**
* | output |
* | --- |
* | "Reset all filter controls" |
*
* @param {Video_Filters_Reset_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_reset_title = /** @type {((inputs?: Video_Filters_Reset_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Reset_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reinitialiser tous les controles de filtre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Filtersteuerungen zurücksetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reimposta tutti i controlli del filtro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сбросить все настройки фильтра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restablecer todos los controles de filtro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重置所有过滤器控制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのフィルターコントロールをリセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी फ़िल्टर नियंत्रण रीसेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reiniciar todos os controles do filtro")
	return /** @type {LocalizedString} */ ("Reset all filter controls")
});